import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';
import { getColor, resolveColorFromKeyword } from '../../helpers/color';
import { CreateCategoryVoiceAction } from '../../types/voice';
import { CommonIcon } from '../common/CommonIcon';

interface ActionCardCreateCategoryViewProps {
  action: CreateCategoryVoiceAction;
}

const hintStyle = { fontSize: 11, color: 'var(--tg-theme-hint-color)' };

export const ActionCardCreateCategoryView: FC<ActionCardCreateCategoryViewProps> = ({ action }) => {
  const iconColor = resolveColorFromKeyword(action.iconColorName!);

  return (
    <Stack direction="row" alignItems="center" gap={0.5} flexShrink={0}>
      <Box
        sx={{
          width: 16,
          height: 16,
          borderRadius: 0.75,
          background: getColor(iconColor),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CommonIcon type="filled" color="var(--tg-theme-text-color)" icon={action.iconName!} size={10} />
      </Box>
      <Text style={hintStyle}>Category</Text>
    </Stack>
  );
};
